import {
  API_URL,
  APPLICATIONINSIGHTS_CONNECTION_STRING,
  CENTRIX_URL,
  FIXAUTO_REDIRECT_URL,
  GOOGLE_EMBED_API_KEY,
  IDS_URL,
  isDevelopment,
  MSAL_CONFIG,
  MUI_X_LICENSE,
  NOVUSGLASS_REDIRECT_URL,
  NPS_CRE_REDIRECT_URL,
  NPS_FIXAUTO_REDIRECT_URL,
  NPS_REDIRECT_URL,
  RECAPTCHA_SITE_KEY,
  SHAREPOINT_URL,
  SPEEDYAUTO_REDIRECT_URL,
  SUPPORT_EMAIL,
  V7_CRE_REDIRECT_URL,
  V7_PROC_REDIRECT_URL,
  V7_REDIRECT_URL,
} from "appConfiguration";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import type { ReactNode } from "react";

const environmentVariables: Record<string, string | undefined> = {
  API_URL,
  IDS_URL,
  CENTRIX_URL,
  APPLICATIONINSIGHTS_CONNECTION_STRING,
  GOOGLE_EMBED_API_KEY,
  NPS_REDIRECT_URL,
  V7_REDIRECT_URL,
  SUPPORT_EMAIL,
  NOVUSGLASS_REDIRECT_URL,
  SPEEDYAUTO_REDIRECT_URL,
  FIXAUTO_REDIRECT_URL,
  NPS_CRE_REDIRECT_URL,
  NPS_FIXAUTO_REDIRECT_URL,
  MUI_X_LICENSE,
  RECAPTCHA_SITE_KEY,
  V7_CRE_REDIRECT_URL,
  V7_PROC_REDIRECT_URL,
  SHAREPOINT_URL,
  MSAL_AUTHORITY: MSAL_CONFIG?.authority,
  MSAL_CLIENT_ID: MSAL_CONFIG?.clientId,
  MSAL_REDIRECT_URI: MSAL_CONFIG?.redirectUri,
};

const missingConfigs = Object.entries(environmentVariables)
  .filter(
    (keyValuePair): keyValuePair is [string, undefined] =>
      keyValuePair[1] === undefined
  )
  .map(([key]) => key);

export function ConfigCheckWrapper({ children }: { children: ReactNode }) {
  if (isDevelopment) {
    return <>{children}</>;
  }
  if (missingConfigs.length === 0) {
    return <>{children}</>;
  }
  return (
    <Container maxWidth="lg">
      <Box component="main" paddingY={2}>
        <Typography variant="h4" color="error.main">
          The following environment variable have not been configured:
        </Typography>
        <ul>
          {missingConfigs.map((variable) => (
            <li key={variable}>
              <strong>{variable}</strong>
            </li>
          ))}
        </ul>
      </Box>
    </Container>
  );
}
